import { createCRUDEndpoints } from '@/api/factory/crud';
import { RegionJSON } from '@/store/models/region';
import { RegionStatus } from '@/store/modules/regions/types';
import httpClient from '../http-client';
import { RequestConfig } from '../types';

type ListParams =
  | {
      search?: string;
      status?: string | number | RegionStatus;
      page?: string | number;
      sort?: string;
      direction?: 'asc' | 'desc';
    }
  | undefined;

export const { list, get, remove, restore } = createCRUDEndpoints<RegionJSON, ListParams, 'id', RegionJSON[]>({
  slug: 'region',
});

export function store(
  regions: (Pick<RegionJSON, 'name' | 'code'> | Pick<RegionJSON, 'id' | 'name' | 'code'>)[],
  config?: RequestConfig,
) {
  return httpClient.post<RegionJSON[]>('regions', regions, config);
}
